import { TextField, Button, Typography, Box, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import Cm_DatePicker from './Cm_DatePicker';
import Cm_DateTimePicker from './Cm_DateTimePicker';
import { Autocomplete_InstantFetch } from './Autocomplete_InstantFetch';

const HideableActionArea = ({ isVisible, height, inputAr, rxVal, rxSetVal }: { isVisible: boolean; height: string; inputAr: any[]; rxVal: any; rxSetVal: any }) => {
  if (!rxSetVal) return;

  const renderInput = (rip: any) => {
    const commonProps = {
      variant: 'outlined' as const,
      sx: {
        // width: Math.floor(100 / inputAr?.length - 1) + 'vw',
        minWidth: '100px',
        // flex: 1,
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: 1,
      },
      value: rxVal?.searchForm?.[rip.reskey] || '',
      onChange: (e) => rxSetVal(rip.reskey, e.target.value),
      label: rip.name,
    };

    switch (rip.type) {
      case 'text':
        return <TextField {...commonProps} key={rip.reskey} />;
      case 'number':
        return <TextField {...commonProps} type="number" key={rip.reskey} />;
      case 'datetime':
        return (
          <Cm_DateTimePicker date={rxVal?.searchForm?.[rip.reskey] || null} setDate={(newDate) => rxSetVal(rip.reskey, newDate)} styling={{ ...commonProps.sx }} renderInput={(params) => <TextField {...params} />} />
        );
      case 'date':
        return <Cm_DatePicker date={rxVal?.searchForm?.[rip.reskey] || null} setDate={(newDate) => rxSetVal(rip.reskey, newDate)} styling={{ ...commonProps.sx }} renderInput={(params) => <TextField {...params} />} />;
      case 'action-button':
        return (
          <Button
            title={rip.title}
            color={rip?.colorj || 'primary'}
            variant={rip.variant || 'contained'}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, ...rip.sx }}
            onClick={() => rip.onClick()}
            key={rip.reskey}
          >
            {rip.name && <Typography>{rip.name}</Typography>}
            {rip.icon && <rip.icon size={20} />}
          </Button>
        );
      case 'autocomplete-fetch':
        return (
          <Autocomplete_InstantFetch
            list={rip.list}
            setList={rip.setlist}
            selectedItem={rip.selectedItem}
            setSelectedItem={rip.setselectedItem}
            fetchApiEndPoint={rip.endPoint}
            variant={rip.variant || 'contained'}
            disabled={rip.disabled === true}
            isRequired={rip.isRequired === true}
            desiredDisplayKey={rip.desiredDisplayKey || 'id'}
            label={rip.label}
            color={rip.colorj || 'primary'}
            sx={rip.sx}
          />
        );
      case 'boolean':
        // return <div>fetch tamam olunca Select koy nullable</div>;
        {
          /* onChange={(event) => handleChangeRowsPerPage(event as React.ChangeEvent<HTMLInputElement>)}  */
        }
        return (
          <FormControl fullWidth>
            <InputLabel htmlFor={`select-label-${rip.reskey}`} sx={{ width: 'min-width', whiteSpace: 'nowrap', paddingTop: '8px' }}>
              {rip.name}
            </InputLabel>
            <Select {...commonProps} native={rip.native || false} inputProps={{ 'aria-label': 'rows per page' }} label="Rows per page" id={`select-label-${rip.reskey}`}>
              <MenuItem value={''}>-</MenuItem>
              <MenuItem value={'true'}>True</MenuItem>
              <MenuItem value={'false'}>False</MenuItem>
            </Select>
          </FormControl>
        );
      default:
        console.warn(`Unsupported rip type: ${rip.type}`);
        return null;
    }
  };

  return (
    <Box
      sx={{
        // backgroundColor: 'theme.palette.primary.main',
        height: isVisible ? height : '0px !important',
        width: isVisible ? '100%' : '0px !important',
        maxWidth: '100%',
        transition: 'all 0.3s ease',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        // flexWrap: 'wrap',
        gap: 1,
      }}
    >
      {inputAr.map((input, index: number) => (
        <Box key={index} sx={{ marginBottom: '0px', padding: '0px' }}>
          {renderInput(input)}
        </Box>
      ))}
    </Box>
  );
};

export default HideableActionArea;
